import React from "react";

const SvgHeartFilled = (props) => (
  <svg viewBox="0 0 16 14" width="16" {...props}>
    <defs>
      <path
        id="filled-heart-path"
        d="M708.99 1629.896c-.163 3.61-2.537 5.438-5.338 8.044a3.868 3.868 0 0 1-2.644 1.054 3.886 3.886 0 0 1-2.641-1.046c-2.832-2.61-5.238-4.45-5.36-8.163-.154-4.664 4.849-6.553 7.682-2.762a.38.38 0 0 0 .306.154.39.39 0 0 0 .314-.159c2.826-3.807 7.897-1.891 7.681 2.878zm-1.597-.08c.143-3.174-2.993-4.225-4.825-1.758a1.95 1.95 0 0 1-1.573.806 1.94 1.94 0 0 1-1.562-.796c-1.873-2.506-4.928-1.392-4.828 1.659.095 2.882 1.925 4.287 4.799 6.936.456.42 1.02.644 1.604.644.584 0 1.148-.224 1.586-.632 2.772-2.58 4.671-4.036 4.799-6.86z"
      />
    </defs>
    <use
      fill={props.color}
      xlinkHref="#filled-heart-path"
      transform="translate(-693 -1625)"
    />
    <path
      d="M7.248 12.6c-.493-.172-.78-.387-1.94-1.452C3.029 9.052 2.267 8.182 1.7 7.023c-.413-.845-.588-1.619-.586-2.597 0-.916.148-1.457.561-2.064.572-.841 1.575-1.25 2.537-1.036.661.147 1.305.542 1.79 1.096.56.644.71.787.967.924.924.492 1.936.31 2.614-.468.464-.533.952-.994 1.223-1.155.892-.528 1.74-.592 2.558-.19 1.101.54 1.665 1.805 1.516 3.4-.139 1.493-.694 2.623-2.013 4.096-.404.451-1.358 1.37-2.793 2.69-.856.788-1.19.953-1.985.981-.449.017-.535.006-.84-.1z"
      opacity={1}
      fill={props.color || "currentColor"}
      fillOpacity={1}
      stroke="none"
      strokeWidth={0.227}
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeMiterlimit={4}
      strokeDasharray="none"
      strokeDashoffset={0}
      strokeOpacity={1}
    />
  </svg>
);

export default SvgHeartFilled;
